import SessionReplaySDK from '@bilibili-business/sessionreplay-jssdk'

const ERROR_WHITE_LIST = [
  'timeout of 6000ms exceeded',
  'window.ReporterPb',
  // 浏览器插件
  'window.uc_translate_context.destroy',
  'window.changeNetWork',
  // 登录页面嵌入的主站登录组件
  'toLowerCase',
  // eslint-disable-next-line quotes
  "Cannot read properties of undefined (reading 'logout')",
  // 性能统计sdk
  // eslint-disable-next-line quotes
  "window.performance.getEntriesByName('first-contentful-paint')[0].startTime",
  // 入驻页面，不影响功能
  'Uncaught ReferenceError: KISSY is not defined',
  // eslint-disable-next-line quotes
  "Cannot read properties of undefined (reading 'update')",
  // SDK和浏览器插件冲突
  // eslint-disable-next-line quotes
  "Failed to execute 'fetch' on 'Window'",
  'The operation is insecure.',
  // eslint-disable-next-line quotes
  "Failed to execute 'getImageData' on 'CanvasRenderingContext2D'", // 不支持的浏览器版本,
  'layoutInstance', // 不支持的浏览器版本,
  'chrome-extension',
  'moz-extension',
  'ms-browser-extension',
  'Error: Permission denied to access property "nodeType"',
  'ResizeObserver loop completed with undelivered notifications.',
  'ResizeObserver loop limit exceeded',
  // videojs 内部 error 不影响功能
  // eslint-disable-next-line quotes
  "Uncaught TypeError: Cannot read properties of null (reading 'aborted')",
  // viewui 组件内部错误 不影响使用
  //  eslint-disable-next-line quotes
  "Cannot set properties of null (setting 'percentage')",
  //  eslint-disable-next-line quotes
  "Cannot set properties of null (setting 'status')",
  // viewui 组件内部错误 不影响使用
  //  eslint-disable-next-line quotes
  "Uncaught TypeError: Cannot set properties of undefined (setting 'style')",
  // viewui 组件内部错误 不影响使用
  //  eslint-disable-next-line quotes
  "Uncaught TypeError: Cannot read properties of undefined (reading 'getElementsByTagName')",
  'window.webkit.messageHandlers.biliInject.biliCallbackReceived',
  //  eslint-disable-next-line quotes
  "Cannot read properties of null (reading 'reset')",
  '[SVGIconNext] fetch icon config failed:'
]

const IGNORE_RESOURCELIST = [
  'https://api.bilibili.com/x/recaptcha/img',
  'https://uat-s1.hdslb.com',
  'sycp/app_icon',
  'https://cnzz2.javasoript.com/api/plugin/',
  'https://utq.vvipquan.com/suv4/',
  'https://speed.ilink-tk.com/spd/',
  'https://c.chuyueshop.com/api/',
  '.geetest.com',
  'https://vip.zhanyangsh.cn/',
  'https://at.alicdn.com/',
  '.bilibili.co',
  '/bfs/security/account'
]
const IGNORE_FILE_LIST = ['chrome-extension', 'moz-extension', 'ms-browser-extension']

function createRegexFromArray(arr) {
  // 使用map遍历数组，对每个字符串进行转义，并用管道符('|')连接
  const escapedRegex = arr.map(str => {
    // 转义正则表达式特殊字符
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  })
  // 将转义后的字符串用管道符('|')连接，形成一个正则表达式
  const regexPattern = escapedRegex.join('|')
  // 创建正则表达式对象
  return new RegExp(regexPattern, 'i') // 'i' 表示忽略大小写
}

const SessionReply = {
  stopRecord: function () {},
  init: function (config) {
    this.stopRecord = SessionReplaySDK.init({
      appId: 'BDIAtYKp_RfkuYQIt8nKR',
      captureNetwork: true,
      eventFilters: {
        errorFilter: event => {
          const reg = createRegexFromArray(ERROR_WHITE_LIST)

          if (event && event.message && reg.test(event.message)) {
            return false
          }
          const error = event?.error || {}

          if (error.stack && reg.test(error.stack)) {
            return false
          }

          // vue error
          if (event.vue && event.stack && reg.test(event.stack)) {
            return false
          }

          // resource ignore
          if (event.target?.localName) {
            const resourceReg = new RegExp(IGNORE_RESOURCELIST.join('|'))
            if (resourceReg.test(event.target?.src) || resourceReg.test(event.target?.href)) {
              return false
            }
          }

          return true
        },
        unhandledRejectionFilter: event => {
          return false
        }
      },
      excludeNetworkMatcher: [/data.bilibili.com\/v2\/log\/web/, /i0.hdslb.com\/bfs\/polaris_web_conf\/polaris\/webcnf\/event.cnf/],
      apiRequestErrorBlackList: [/data.bilibili.com\/v2\/log\/web/, /\/bfs\/polaris_web_conf\/polaris\/webcnf\/event.cnf/],
      ...config
    })
  },
  setAccountId(accountId) {
    SessionReplaySDK.setUser(accountId)
  },
  setError(error) {
    SessionReplaySDK.addAppErrorEvent({ error })
  }
}

export { SessionReply }
